/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import TextInput from "../TextInput";
import ColorPickerProps from "./ColorPickerProps";

export default function ColorPicker(props: ColorPickerProps) {
    function handleChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        const value = e.target.value;
        props.onChange(value);
    }

    return (
        <TextInput
            {...props}
            value={props.value}
            onChange={handleChange}
            type="color"
        />
    )
}